import { useSyncExternalStore } from 'react'
import type { StorageItem } from './storageItem'

/**
 * Reads a storage item during render and re-renders whenever it changes, whether the write came from
 * another component, from code outside React or from another tab. The stored value is known on the
 * very first render, so a default never flashes before it.
 */
export const useStorageItem = <T>(item: StorageItem<T>) => {
  const value = useSyncExternalStore(item.subscribe, item.get, item.get)

  return [value, item.set] as const
}
